<template>
  <div class="team_draw" :style="{'padding-top': showTopTit ? '4.06rem' : '3.6rem','background-position': showTopTit ? 'top 0.46rem center': 'top center'}">
    <div v-if="showTopTit" class="topTit" id="topTit" ref="topTit">
      <van-icon @click.stop="goBack" name="arrow-left" color="#515151" size="0.28rem" />
      <van-notice-bar class="navText" color="#333" background="#fff" v-if="topTitle">{{topTitle}}</van-notice-bar>
      <div class="refresh" @click.stop="refreshClick">
        <img src="~assets/images/recmmendImg/refresh.png" />
      </div>
    </div>
    <div class="maskLoading" v-show="maskLoadingflag">
        <img src="~assets/images/load.svg" alt />
    </div>
      <div class="time">{{activeTime}}，组队参与每天抽奖，赢王者荣耀皮肤</div>
      <span v-show="!teamCode">
        <img class="btn-item btn-scale" @click="getTeamSkinTeamCreate()" src="~assets/teamDraw/btn-sponsor-team.png" alt="">
        <img class="btn-item" @click="joinTeam" style="margin-top:0.265rem" src="~assets/teamDraw/btn-join-team.png" alt="">
      </span>
      <div class="team-frame" v-show="teamCode">
        <div class="frame-circle frame-top"></div>
        <div class="frame-circle frame-right"></div>
        <div class="frame-circle frame-bottom"></div>
        <div class="frame-circle frame-left"></div>
        <div class="border-upright"></div>
        <div class="border-across"></div>
        <div class="real-content">
            <div class="team-frame-title">
                <span class="panel-name">
                    队伍编号：{{teamCode}}
                    <img class="btn-copy copyName" @click="copyGiftCode(teamCode)" src="~assets/teamDraw/icon-copy-yellow.png" alt="">
                </span>
                <span class="panel-statue">{{userList.length > 1 ? '组队完成' : '组队中'}}</span>
            </div>
            <img v-show="showShareBtn" @click="openSharePopup('team_area_invite_btn')" style="width:2.08rem" class="btn-share btn-active btn-scale" src="~assets/teamDraw/btn-share-join.png" alt="">
            <img v-show="!showShareBtn && userList.length === 1" class="btn-share btn-active btn-scale" @click="openSharePopup('team_area_invite_btn')" src="~assets/teamDraw/btn-recruit.png" alt="">
            <img v-show="!showShareBtn && userList.length > 1" class="btn-share btn-active" @click="openSharePopup('team_area_invite_btn')" src="~assets/teamDraw/btn-share.png" alt="">
            <div class="team-user">
                <div class="frame-circle team-top"></div>
                <div class="frame-circle team-right"></div>
                <div class="frame-circle team-bottom"></div>
                <div class="frame-circle team-left"></div>
                <div class="team-border-upright"></div>
                <div class="team-border-across"></div>
                <div></div>
                <div class="user-list">
                    <div class="user-list-title">
                        小队成员
                        <img v-show="!showShareBtn && userList.length < 2" @click="teamSkinTeamBreak" class="dissolve-team btn-active" src="~assets/teamDraw/dissolve-team.png" alt="">
                    </div>
                    <div class="user-row" v-for="item in userList" :key="item.uuid">
                        <img :src="item.portrait" alt="">
                        {{item.name}}
                    </div>
                    <div class="user-row" v-show="userList.length < 2">
                        <img class="btn-active"  @click="openSharePopup('team_area_user_portrait')" src="~assets/teamDraw/user-add.png" alt="">
                    </div>
                </div>

            </div>
            <div class="activity-text">
                <span>温馨提示：活动期间，组队成功后队伍所有成员每天可以开三次盲盒，免费赢王者荣耀皮肤。</span>
            </div>
        </div>
      </div>
      <div class="team-frame" v-show="teamCode && !showShareBtn" style="margin-top:0.32rem">
        <div class="frame-circle frame-top"></div>
        <div class="frame-circle frame-right"></div>
        <div class="frame-circle frame-bottom"></div>
        <div class="frame-circle frame-left"></div>
        <div class="border-upright"></div>
        <div class="border-across"></div>
        <div class="real-content">
            <div class="team-frame-title">
                <span class="panel-name">今日盲盒</span>
                <span class="panel-time">还剩{{diffTime}}小时刷新</span>
            </div>
            <div class="award-list">
                <div class="award-row" v-for="award in 3" :key="'award' + award">
                    <img class="award-row-box" src="~assets/teamDraw/icon-box-close.png" alt="">
                    <img v-show="userList.length < 2" class="award-row-btn" @click="openSharePopup('box_area')" src="~assets/teamDraw/box-active.png" alt="">
                    <img @click="teamSkinWheel(award)" v-show="userList.length === 2 && !teamSkinWheelObj[award]" class="award-row-btn btn-active" src="~assets/teamDraw/box-open.png" alt="">
                    <img v-show="userList.length === 2 && teamSkinWheelObj[award]" class="award-row-btn" src="~assets/teamDraw/box-opened.png" alt="">
                </div>
            </div>
        </div>
      </div>
      <img class="title-award" src="~assets/teamDraw/title-award.png" alt="">
      <div class="award-show">
          <div class="award-row-out" :style="{marginLeft:index === 6 ? '0.58rem' : '',marginRight:index === 7 ? '0.58rem' : ''}" v-for="(item,index) in awardDisplayList" :key="item.propId">
              <img :src="item.icon" alt="">
              <!-- <div class="out-circle out-top"></div>
              <div class="out-circle out-right"></div>
              <div class="out-circle out-bottom"></div>
              <div class="out-circle out-left"></div>
              <div class="award-row-in">
                <img class="award-img" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1608445693539&di=e7f1277b881fa8f6a7f890ae51a51dae&imgtype=0&src=http%3A%2F%2Fpic1.win4000.com%2Fmobile%2F2019-02-27%2F5c767a487846a.jpg" alt="">
                <div class="in-circle in-top"></div>
                <div class="in-circle in-right"></div>
                <div class="in-circle in-bottom"></div>
                <div class="in-circle in-left"></div>
              </div> -->
              <div class="award-name">{{item.propName}}</div>
          </div>
      </div>
      <div class="share-mask" v-show="showPopup" @click="showPopup = false"></div>
        <div class="share-menu" :style="{bottom:showPopup ? '0' : '-3.12rem',visibility:showPopup ? 'visible' : 'hidden'}">
            <div class="type-text">通过以下方式招募好友</div>
            <img style="margin-top:0.24rem" src="~assets/teamDraw/type-line-1.png" class="type-line" />
            <div class="share-panel">
                <div class="share-box" @click="shareWeb(0x1,'event_new_share_click')">
                    <img src="~assets/teamDraw/icon-wechat.png" alt="">
                    微信
                </div>
                <div class="share-box" @click="shareWeb(0x2,'event_new_share_click')">
                    <img src="~assets/teamDraw/icon-circle.png" alt="">
                    朋友圈
                </div>
                <div class="share-box" @click="shareWeb(0x3,'event_new_share_click')">
                    <img src="~assets/teamDraw/icon-qq.png" alt="">
                    QQ
                </div>
                <div class="share-box" @click="shareWeb(0x4,'event_new_share_click')">
                    <img src="~assets/teamDraw/icon-zone.png" alt="">
                    QQ空间
                </div>
            </div>
            <img src="~assets/teamDraw/type-line-2.png" class="type-line" />
            <img class="share-text" src="~assets/teamDraw/share-text.png" alt="">
        </div>
    <div class="guidancemask" v-show="showGuidance" @click="showGuidance = false">
        <img class="guidancemask-img" src="~assets/images/guide_icon.png" alt="">
    </div>
      <Model @getTeamSkinTeamCreate="getTeamSkinTeamCreate" @shareWeb="shareWeb" @teamSkinTeamJoin="teamSkinTeamJoin" @closeMask="closeMask" :maskType="maskType" ref="Model"></Model>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup,Dialog,NoticeBar,Icon } from 'vant';
import Model from '@/components/teamDraw/Model'
import config from "@/../config";
import active from '@/utils/axios/index';
import primaryApi from "@/utils/primaryApi";
import qs from "qs";
import moment from "moment";
import { openApp } from "@/utils/utils";
import Clipboard from 'clipboard'
import { mapState } from "vuex";
Vue.use(Popup,Dialog);
Vue.use(Icon);
Vue.use(NoticeBar);
export default {
inject: ["reload"],
components: {
    Model
},
computed: {
    ...mapState([
      "uuid"
    ]),
  },
  data() {
    return {
        maskType: false,
        activityStep: 2,
        showPopup: false,
        activityId:'',
        showTopTit:false,
        maskLoadingflag:true, // 页面载入状态
        teamSkinWheelObj: {}, // 今日抽奖次数
        teamCode: '', // 当前队伍码
        entryObj:{}, // 活动基础信息
        topTitle:{}, // 活动标题
        activeTime:'', // 活动时间
        userList:[], // 队伍信息
        globalStates:{},
        shareUrlArr:[],
        shareData: {}, // 分享模块信息
        shareModuleId:'',
        awardDisplayList:[],
        diffTime:'00:00:00',
        setIntervalTimer:'',
        showGuidance:false,
        firstEnter:true,
        showShareBtn:false
    }
  },
  watch:{

  },
created () {
    this.activityId = this.$route.query.id
    /* 状态管理 */
    if (this.$route.query.f) {
        // 通过链接中是否存在分享id，判断是否通过分享进入
        this.globalStates = {
            shareParams: {
                locationId: parseInt(this.$route.query.f), // 分享功能ID
                relationship: parseInt(this.$route.query.g), // 分享关系
                relationshipParams: parseInt(this.$route.query.c), // 分享关系参数
                parentUUID: this.$route.query.u, // 分享人的UUID
                scheme: "",
                parentName: this.$route.query.n || "none", // 分享人的用户名
            },
        };
    } else {
        // 非分享进入，分享中转信息写死
        this.globalStates = {
            shareParams: {
                locationId: this.activityId, // 分享功能ID
                relationship: 5, // 分享关系
                relationshipParams: this.activityId, // 分享关系参数
                parentUUID: "none", // 分享人的UUID
                scheme: "",
                parentName: "none", // 分享人的用户名
            },
        };
    }
    if (primaryApi && primaryApi.isSource == "pd" || primaryApi.isSource == "sg") {
        primaryApi.setNativeTitleShow(false); // 隐藏原生顶栏
        // 乐园显示顶部导航栏
        this.showTopTit = true;
    }else{
            let ua = navigator.userAgent.toLowerCase();
            const browserType = /\sQQ\//.test(navigator.userAgent) ? 1 : ua.match(/MicroMessenger/i) == "micromessenger" ? 2 : 0
            this.$tea('event_new_share_landing_open', { 
                'locationId':202,
                'relationship':5,
                'landingPage':'activepage',
                'relationshipExtra2':this.activityId,
                'parentUUID':this.$route.query.u,
                'landingParam':this.activityId,
                browserType
            });//分享按钮点击
    }
    if(this.$route.query.f && !primaryApi.isSource){
        this.showShareBtn = true
    }
    this.entry()
    this.getuuid();
  },
  mounted(){
      window.clearInterval(this.setIntervalTimer)
      this.setIntervalTimer = setInterval(this.computedTime,1000)
        //233乐园后退回调
        window["goBackResult"] = (result) => {
            if (result == "failed") {
                //乐园后退失败则关闭界面
                primaryApi.closeActivity();
            }
        };
  },
  methods:{
    //刷新
    refreshClick() {
      this.reload();
    },
    //后退
    goBack() {
      if (primaryApi.isSource == "pd" || primaryApi.isSource == "sg") {
        //乐园环境
        primaryApi.goBack();
      }
    },
    // 获取uuid
    getuuid() {
      if (primaryApi.isSource == "pd" || primaryApi.isSource == "sg") {
        this.userInfo = JSON.parse(primaryApi.getUserInfo());
      } else {
        this.userInfo = {
          uuId: this.$route.query.u || "9999",
          onlyId: "",
          userName: "测试用户名",
          isGuest:true
        };
      }
        var uuid = primaryApi.isSource == "sg" ? this.userInfo.uuid : this.userInfo.uuId;
        var onlyId = this.userInfo.onlyId;
        var userName = this.userInfo.userName;
        this.$store.commit({
          type: "setuuid",
          uuid,
        });
        this.$store.commit({
          type: "setonlyid",
          onlyId,
        });
        this.$store.commit({
          type: "setuserName",
          userName,
        });
        this.getTeamSkinInfo()
    },
    computedTime(){
      this.diffTime = new moment(new moment(new moment().endOf('day').format('x') - new moment().format('x')) - 8 * 3600 * 1000).format('HH:mm:ss')
      if((new moment().endOf('day').format('x') - new moment().format('x')) < 0){
          this.getTeamSkinInfo()
      }
    },
    // 复制队伍码
    copyGiftCode(code) {
        if (primaryApi.isSource) { // 判断运行环境是否233
            primaryApi.writeClipBoard(code); // 233app内复制邀请码到剪切板
            this.$toast('已复制到剪切板');
        } else {
            let clipboard = new Clipboard('.copyName', {
                text: function () {
                    return code
                }
            });
            clipboard.on('success', e => {
                this.$toast('已复制到剪切板');
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on('error', e => {
                this.$toast('复制失败');
                clipboard.destroy();
            });
        }
    },
    joinTeam(){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.$tea('event_active_join_team_btn_click', { 'activityId': this.activityId});//点击加入组队
        this.maskType = 'joinTeam'
        this.$tea('event_active_join_team_popup_show', { 'activityId': this.activityId, method:'clickbtn'});//加入组队弹窗展示	
    },
    openSharePopup(type){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.$tea('event_active_invite_friend_btn_click', { 'activityId': this.activityId,placement:type});//邀请好友按钮点击
        this.showPopup = true
        this.$tea('event_new_share_open', { 'activityId': this.activityId, modul:-1,locationId:202,relationship:5,relationshipExtra2:this.activityId,pos:2001}); // 分享打开
    },
    closeMask(){
        this.maskType = false
    },
    // 判断运行环境是否233
    correctTerminal() {
        if (primaryApi.isSource == "pd" || primaryApi.isSource == "sg") {
            return true;
        } else {
            let ua = navigator.userAgent.toLowerCase();
            const browserType = /\sQQ\//.test(navigator.userAgent) ? 1 : ua.match(/MicroMessenger/i) == "micromessenger" ? 2 : 0
            const activeObj = {
                activityId:this.activityId,
                relationship:4,
                locationId:202,
                relationship:5,
                relationshipExtra2:this.activityId,
                'parentUUID':this.$route.query.u,
                'landingParam':this.activityId,
                browserType
            } // 活动相关数据
            if(ua.match(/MicroMessenger/i) == "micromessenger"){
                this.showGuidance = true
            }
            openApp(activeObj,this.globalStates,'teamDraw')
            // Dialog.confirm({
            //     title: '打开233乐园 赢取好礼',
            //     message: '参加活动，赢取游戏好礼，233乐园【活动专区】更多游戏礼物等你来领取',
            // }).then(() => {
            //     const activeObj = {
            //         activityId:this.activityId,
            //         relationship:4,
            //         guide:this.guide
            //     } // 活动相关数据
            //     openApp(activeObj,this.globalStates,'teamDraw')
            // }).catch(() =>{})
            return false;
        }
    },
    // 页面初始化渲染
    entry() {
        active.entry(config.API_HOST + "/apiserv/api/activity/entry", qs.stringify({
            id: this.activityId,
        })).then((res) => {
            this.maskLoadingflag = false;
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            this.entryObj = res.data;
            this.topTitle = res.data.activityClient.productName; //活动标题
            this.activeTime = new moment(res.data.activityServer.startTime).format('M.D') + '-' + new moment(res.data.activityServer.endTime).format('M.D日')
            for(var i = 0; i< res.data.contentShow.length; i++){
                if(res.data.contentShow[i].indexOf('share') > -1){
                    this.shareModuleId = res.data.contentShow[i].split("_")[1]
                    this.shareInfo();
                    this.getShareCsvByLocationId();
                }
                if(res.data.contentShow[i].indexOf('awardDisplay') > -1){
                    this.getAwardDisplayList(res.data.contentShow[i].split("_")[1])
                }
            }
        }).catch((error) => {
            this.maskLoadingflag = false;
            this.$toast("网络不稳定，请稍后");
        });
    },
    getTeamSkinInfo(){
        active.getTeamSkinInfo(config.API_HOST + "/apiserv/api/activity/teamSkin/personalInfo", {
            activityId:this.activityId,
            uuid:this.uuid,
        }).then((res) => {
            if (res.code != 200) {
                this.$toast(res.message);
                return;
            }
            this.globalStates.shareParams.teamCode = res.data.teamCode || ''
            this.teamSkinWheelObj = res.data.teamSkinWheel || {}
            this.teamCode = res.data.teamCode || ''
            if(this.teamCode){
                this.getTeamSkinTeamInfo()
            }
            if(primaryApi.isSource == "pd" || primaryApi.isSource == "sg"){
                if(this.teamCode){
                    this.$tea('event_active_team_page_show', { 'activityId': this.activityId});//进入活动组队页
                }else{
                    this.$tea('event_active_show', { 'activityId': this.activityId}); //进入活动页
                }
            }
            if(this.$route.query.teamCode && primaryApi.isSource && !this.teamCode && this.firstEnter && this.$route.query.u !== this.uuid){
                this.maskType = 'joinTeam'
                this.$tea('event_active_join_team_popup_show', { 'activityId': this.activityId, method:'auto'});//加入组队弹窗展示	
                this.$refs.Model.autoInput = true
                this.$refs.Model.teamCode = this.$route.query.teamCode
            } // 在233内打开自动填充teamCode
            this.firstEnter = false
        }).catch((error) => {
            this.$toast("网络不稳定，请稍后");
        });
    },
    getTeamSkinTeamInfo(){
        active.getTeamSkinTeamInfo(config.API_HOST + "/apiserv/api/activity/teamSkin/teamInfo", {
            activityId:this.activityId,
            teamCode:this.teamCode,
        }).then((res) => {
            if (res.code != 200) {
                this.$toast(res.message);
                return;
            }
            this.userList = res.data
        }).catch((error) => {
            this.$toast("网络不稳定，请稍后");
        });
    },
    getTeamSkinTeamCreate(type){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.$tea('event_active_build_team', { 'activityId': this.activityId,'placement': type === 'popup' ? 'join_fail_popup' : 'homepage'});// 创建组队
        active.getTeamSkinTeamCreate(config.API_HOST + "/apiserv/api/activity/teamSkin/teamCreate", qs.stringify({
            activityId:this.activityId,
            uuid:this.uuid,
        })).then((res) => {
            if (res.code != 200) {
                this.$toast(res.message);
                return;
            }
            this.teamCode = res.data
            this.maskType = 'success'
            this.$tea('event_active_bt_success_popup_show', { 'activityId': this.activityId});// 组队成功弹窗展示	
            this.$refs.Model.successCode = res.data
            this.$refs.Model.teamCode = ''
            this.$refs.Model.autoInput = false
            this.getTeamSkinInfo()
        }).catch((error) => {
            this.$toast("网络不稳定，请稍后");
        });
    },
    teamSkinTeamBreak(){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        Dialog.confirm({
            title: '温馨提示',
            message: '确认解散队伍',
        }).then(() => {
            active.teamSkinTeamBreak(config.API_HOST + "/apiserv/api/activity/teamSkin/teamBreak", qs.stringify({
                activityId:this.activityId,
                teamCode:this.teamCode,
            })).then((res) => {
                this.$tea('event_active_disband_team', { 'activityId': this.activityId, result:res.code == 200 ? 'success' : 'fail'});//解散队伍	
                if (res.code != 200) {
                    this.$toast(res.message);
                    return;
                }
                this.getTeamSkinInfo()
            }).catch((error) => {
                this.$toast("网络不稳定，请稍后");
            });
        }).catch(() =>{})
    },
    teamSkinTeamJoin(teamCode) {
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        if(teamCode.trim().length !== 8){
            this.$toast('请输入正确的队伍编号');
            return
        }
        active.teamSkinTeamJoin(config.API_HOST + "/apiserv/api/activity/teamSkin/teamJoin", qs.stringify({
            activityId:this.activityId,
            teamCode:teamCode.trim(),
            uuid:this.uuid
        })).then((res) => {
            if (res.code != 200) {
                this.$tea('event_active_join_team_fail', { 'activityId': this.activityId, failmsg:res.message});//加入队伍失败
                if(res.message === '队伍不存在'){
                    this.maskType = 'joinTeamFail1'
                }else if(res.message === '队伍已满员'){
                    this.maskType = 'joinTeamFail2'
                }else{
                    this.$toast(res.message);
                }
                return;
            }
            this.$tea('event_active_join_team_success', { 'activityId': this.activityId});//加入队伍成功	
            this.maskType = false
            this.getTeamSkinInfo()
        }).catch((error) => {
            this.$toast("网络不稳定，请稍后");
        });
    },
    teamSkinWheel(num){
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        this.$tea('event_active_open_box', { 'activityId': this.activityId});//开启盲盒		
        active.teamSkinWheel(config.API_HOST +'/apiserv/api/activity/teamSkin/wheel', qs.stringify({
            uuid:this.uuid,
            activityId: this.activityId,
            num
        })).then((res) => {
            if(res.return_code == 200 || res.code == 200){
                this.teamSkinWheelObj[num] = true
                this.$tea('event_active_box_result_page_show', { 'activityId': this.activityId});//盲盒结果展示			
                this.maskType = 'fail'
            }else{
                this.$toast(res.return_msg || res.message)
            }
        })
    },
    // 获取大奖展示列表
    getAwardDisplayList(moduleId){
        active.getAwardDisplayList(config.API_HOST +'/apiserv/api/activity/checkinShare/awardList', {
            moduleId,
            activityId: this.activityId
        }).then((res) => {
            if(res.return_code == 200 || res.code == 200){
                this.awardDisplayList = res.data
            }else{
                this.$toast(res.return_msg || res.message)
            }
        })
    },
    // 获取分享域名
    getShareCsvByLocationId() {
        active.shareInfo(config.API_HOST + "/apiserv/api/share/getShareCsvByLocationId", { 
            locationId: 202 // 定制活动:202,活动模板:201
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            this.shareUrlArr = res.data;
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 获取分享模块信息
    shareInfo() {
        active.shareInfo(config.API_HOST + "/apiserv/api/activity/share/shareInfo", { 
            activityId: this.activityId,
            moduleId: this.shareModuleId,
            uuid: this.uuid
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
            // 1-微信，2-朋友圈，3-QQ，4-QQ空间
            res.data.activityContentShare.btnArr = res.data.activityContentShare.btn.split(';');
            this.shareData = res.data.activityContentShare;
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
        // 分享
    shareWeb(shareType,type) {
        if (!this.correctTerminal()) { // 判断运行环境是否是233
            return false;
        }
        if(type === 'event_new_share_click'){
            this.$tea(type, { 
                'activityId': this.activityId,
                'modul':-1,
                'locationId':202,
                'relationship':5,
                'relationshipExtra2':this.activityId,
                'pos':2001,
                shareType,
            });//分享按钮点击			
        }else{
            this.$tea(type, { 'activityId': this.activityId});//组队成功分享点击			
        }
        let shareStyle;
        let teaShareType; // 埋点分享类型
        let url;
        let shareUrl;
        switch(shareType) {
            case 0x1:
                shareStyle = 0x15;
                teaShareType = 1;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "1") { // shareApp = 1微信、2朋友圈、3QQ、4QQ空间
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x2:
                shareStyle = 0x16;
                teaShareType = 2;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "2") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x3:
                shareStyle = 0x1f;
                teaShareType = 3;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "3") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
            case 0x4:
                shareStyle = 0x20;
                teaShareType = 4;
                this.shareUrlArr.map(item => {
                    if (item.shareApp == "4") {
                        shareUrl = item.domain.domain;
                    }
                });
                break;
        }
        const env = window._API_HOST().NODE_ENV
        const shareBaseHost = window._API_HOST().shareBaseHost
        if (env === "production") { // 正式服
            url = shareUrl;
        } else { // 测试，预发
            url =  shareBaseHost;
        }
        let shareInfo = {
            // 分享网页4个参数
            targetUrl: url + 'teamDraw?id=' + this.activityId + '&u=' + this.uuid + '&f=202' + '&g=4' + '&c=' + this.activityId + '&teamCode=' + this.teamCode, // 分享链接 f-分享功能ID,g-分享关系,c-分享关系参数,u-分享人的UUID
            title: this.shareData.title, // 分享标题
            desc: this.shareData.shareDescribe, // 分享描述
            imgUrl: this.shareData.icon, // 分享图标
            // web
            shareType: shareType, // Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
            shareStyle: shareStyle, // 落地分享展现方式, 只分享文字 0xB,微信网页 0x15,微信朋友圈分享网页 0x16,qq分享网页 0x1f,qq空间分享网页 0x20
            isWeb: true, // 是否由web端创建对话框
            locationId: 202, //Int 功能ID
            relationship: 4, //Int 关系（3:游戏分享）
            relationshipExtra: this.activityId, //Long关系参数（3：gameId） string
            pos: 2001, //Int APP进入位置
            posExtra: this.activityId //Long APP进入位置参数
        };
        if (primaryApi.share(shareInfo)) {// 调用安卓api分享
            // 默认唤起Android分享成功即分享成功
            this.shareSignal();
        }
    },
    // 通知服务端分享成功
    shareSignal() {
        active.shareSignal(config.API_HOST + "/apiserv/api/activity/share/shareSignal", { 
            activityId: this.activityId,
            moduleId: this.shareModuleId,
            uuid: this.uuid
        }).then((res) => {
            if (res.return_code != 200) {
                this.$toast(res.return_msg);
                return;
            }
        }).catch((error) => {
            this.$toast('网络不稳定，请稍后');
        });
    },
    // 判断活动状态
    lock() {
        if (this.activityStatus == 0) {
            //活动展示期
            this.$toast('【' + this.entryObj.activityServer.startTime + '】开启活动');
            return false;
        } else if (this.activityStatus == 1) {
            this.disabled = false;
            return true;
        } else if (this.activityStatus == 2) {
            this.$toast('活动已结束，请等待下次活动');
            return false;
        } else {
            this.$toast('活动已结束，请等待下次活动');
            return false;
        }
    },
  }
}
</script>

<style scoped>
    .share-mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3333;
        background: rgba(0,0,0,0.6)
    }
    .guidancemask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: rgba(0,0,0,0.75);
        padding-left: 25px;
    }
    .guidancemask-img{
        width: 300px;
        display: block;
        margin: 10px auto;
    }
    .topTit {
        width: 100%;
        height: 0.46rem;
        line-height: 0.46rem;
        background-color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 998;
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 0 0.05rem;
    }
    .refresh {
        height: 100%;
        width: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        font-size: 0;
    }
    .refresh img {
        width: 22.8px;
        height: 30.6px;
    }
    .refresh span {
        color: #515151;
        font-size: 0.06rem;
        line-height: 0.2rem;
        /* transform: scale(0.9, 0.9); */
        margin-top: -0.1rem;
    }
    .van-notice-bar {
        width: 100%;
        text-align: center;
        font-size: 0.16rem;
        padding: 0 0.1rem;
    }
    .navText >>> .van-notice-bar__content {
        text-align: center;
        min-width: 100%;
    }
    .maskLoading {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        background: rgba(189, 84, 28, 0.98);
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .maskLoading img {
        display: block;
        width: 0.4rem;
        height: 0.4rem;
        animation: loading 2s linear 0s infinite;
    }
    @keyframes loading {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }
    .team_draw{
        width: 100%;
        background-image: url('~assets/teamDraw/bg-team-draw.png');
        background-size: 100% 12.5rem;
        background-repeat: no-repeat;
        background-position: top 0.46rem center;
        padding-top: 4.06rem;
        background-color: #1B1D42;
        min-height: 100vh;
    }
    .btn-item{
        width: 260px;
        height: 42px;
        margin: 0 auto;
        display: block;
    }
    .btn-item:active{
        transform: scale(0.9);
    }
    .award-show{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 0 8px;
    }
    .award-row-out{
        width: 116px;
        height: 171px;
        /* border: solid 1px #E7D38A; */
        margin-bottom: 48px;
        position: relative;
        padding: 5px;
    }
    .award-row-out img{
        width: 100%;
        height: 100%;
    }
    .award-row-in{
        width: 100%;
        height: 100%;
        border: solid 1px #E7D38A;
        position: relative;
    }
    .out-circle{
        width: 9px;
        height: 9px;
        position: absolute;
        background: rgb(29,35,73);
        z-index: 10;
    }
    .in-circle{
        width: 7px;
        height: 7px;
        position: absolute;
        background: rgb(29,35,73);
    }
    .out-top, .in-top{
        left: -1px;
        top: -1px;
        border-right: solid 1px #E7D38A;
        border-bottom: solid 1px #E7D38A;
    }
    .out-top{
        border-radius: 0 0 9px 0;
    }
    .in-top{
        border-radius: 0 0 7px 0;
    }
    .out-right, .in-right{
        right: -1px;
        top: -1px;
        border-left: solid 1px #E7D38A;
        border-bottom: solid 1px #E7D38A;
    }
    .out-right{
        border-radius: 0 0 0 9px;
    }
    .in-right{
        border-radius: 0 0 0 7px;
    }
    .out-bottom, .in-bottom{
        right: -1px;
        bottom: -1px;
        border-left: solid 1px #E7D38A;
        border-top: solid 1px #E7D38A;
    }
    .out-bottom{
        border-radius: 9px 0 0 0;
    }
    .in-bottom{
        border-radius: 7px 0 0 0;
    }
    .out-left, .in-left{
        left: -1px;
        bottom: -1px;
        border-right: solid 1px #E7D38A;
        border-top: solid 1px #E7D38A;
    }
    .out-left{
        border-radius: 0 9px 0 0;
    }
    .in-left{
        border-radius: 0 7px 0 0;
    }
    .award-img{
        width: 100%;
        height: 100%;
    }
    .award-name{
        width: 100%;
        color: #8FE8D3;
        text-align: center;
        position: absolute;
        top: 1.82rem;
        font-size: 0.12rem;
        left: 0;
        letter-spacing: 0.1em;
    }
    .title-award{
        width: 3.32rem;
        height: 0.2rem;
        display: block;
        margin: 0.4rem auto;
    }
    .time{
        text-align: center;
        font-size: 0.12rem;
        color: #8FE8D3;
        /* transform: scale(0.9); */
        margin-bottom: 0.44rem;
    }
    .team-frame{
        width: 3.42rem;
        position: relative;
        margin: 0 auto;
        padding: 0.1rem 0.17rem 0.13rem 0.17rem;
    }
    .frame-circle{
        background: none;
        width: 8px;
        height: 8px;
        position: absolute;
        z-index: 10;
        background: rgb(24,27,63);
    }
    .frame-top{
        left: 0;
        top: 0;
        border-right: solid 1px #EFCE6D;
        border-bottom: solid 1px #EFCE6D;
        border-radius: 0 0 8px 0;
    }
    .frame-right{
        right: 0;
        top: 0;
        border-left: solid 1px #EFCE6D;
        border-bottom: solid 1px #EFCE6D;
        border-radius: 0 0 0 8px;
    }
    .frame-bottom{
        right: 0;
        bottom: 0;
        border-left: solid 1px #EFCE6D;
        border-top: solid 1px #EFCE6D;
        border-radius: 8px 0 0 0;
    }
    .frame-left{
        left: 0;
        bottom: 0;
        border-right: solid 1px #EFCE6D;
        border-top: solid 1px #EFCE6D;
        border-radius: 0 8px 0 0;
    }
    .border-upright{
        /* background: rgba(35, 81, 123, .7); */
        border-right: 1px solid #EFCE6D;
        border-left: 1px solid #EFCE6D;
        width: 100%;
        height: calc(100% - 16px);
        position: absolute;
        left: 0;
        top: 8px;
    }
    .border-upright::after{
        content: "";
        width: 7px;
        height: calc(100% + 8px);
        background: rgba(35, 81, 123, .7);
        position: absolute;
        right: 0;
        top: -4px;
    }
    .border-upright::before{
        content: "";
        width: 7px;
        height: calc(100% + 8px);
        background: rgba(35, 81, 123, .7);
        position: absolute;
        left: 0;
        top: -4px;
    }
    .border-across{
        background: rgba(35, 81, 123, .7);
        border-top: 1px solid #EFCE6D;
        border-bottom: 1px solid #EFCE6D;
        width: calc(100% - 16px);
        height: 100%;
        position: absolute;
        left: 8px;
        top: 0;
    }
    .real-content{
        position: relative;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 12;
    }
    .team-frame-title{
        position: relative;
    }
    .panel-name{
        width: 100%;
        font-weight: bold;
        color: #131135;
        background: linear-gradient(0deg, #FAF7B0 0%, #EFB858 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 0.19rem;
        position: relative;
    }
    .panel-statue{
        font-weight: bold;
        color: #131135;
        background: linear-gradient(0deg, #FAF7B0 0%, #EFB858 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 0.12rem;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .btn-share{
        width: 1.77rem;
        height: 0.42rem;
        display: block;
        margin: 0.3rem auto 0 auto;
    }
    .team-user{
        width: 3.08rem;
        height: 1.18rem;
        margin: 0.33rem auto 0.15rem auto;
        position: relative;
    }
    .team-user .frame-circle{
        background: none;
        width: 8px;
        height: 8px;
        position: absolute;
        z-index: 10;
        background: rgba(32, 65, 105);
    }
    .team-border-upright{
        background: #1B2E55;
        border-right: 1px solid rgba(239, 206, 109, 0.4);
        border-left: 1px solid rgba(239, 206, 109, 0.4);
        width: 100%;
        height: calc(100% - 16px);
        position: absolute;
        left: 0;
        top: 8px;
    }
    .team-border-upright::after{
        content: "";
        width: 7px;
        height: calc(100% + 8px);
        background: #1B2E55;
        position: absolute;
        right: 0;
        top: -4px;
    }
    .team-border-upright::before{
        content: "";
        width: 7px;
        height: calc(100% + 8px);
        background: #1B2E55;
        position: absolute;
        left: 0;
        top: -4px;
    }
    .team-border-across{
        background: #1B2E55;
        border-top: 1px solid rgba(239, 206, 109, 0.4);
        border-bottom: 1px solid rgba(239, 206, 109, 0.4);
        width: calc(100% - 16px);
        height: 100%;
        position: absolute;
        left: 8px;
        top: 0;
    }
    .team-top{
        left: 0;
        top: 0;
        border-right: solid 1px rgba(239, 206, 109, 0.4);
        border-bottom: solid 1px rgba(239, 206, 109, 0.4);
        border-radius: 0 0 8px 0;
    }
    .team-right{
        right: 0;
        top: 0;
        border-left: solid 1px rgba(239, 206, 109, 0.4);
        border-bottom: solid 1px rgba(239, 206, 109, 0.4);
        border-radius: 0 0 0 8px;
    }
    .team-bottom{
        right: 0;
        bottom: 0;
        border-left: solid 1px rgba(239, 206, 109, 0.4);
        border-top: solid 1px rgba(239, 206, 109, 0.4);
        border-radius: 8px 0 0 0;
    }
    .team-left{
        left: 0;
        bottom: 0;
        border-right: solid 1px rgba(239, 206, 109, 0.4);
        border-top: solid 1px rgba(239, 206, 109, 0.4);
        border-radius: 0 8px 0 0;
    }
    .user-list{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        padding: 0 0.1rem;
    }
    .user-list-title{
        width: 100%;
        height: 0.32rem;
        width: 100%;
        font-weight: bold;
        color: #131135;
        background: linear-gradient(0deg, #FAF7B0 0%, #EFB858 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: left;
        font-size: 0.15rem;
        padding: 0.08rem 0.06rem;
        line-height: 0.16rem;
        position: relative;
    }
    .dissolve-team{
        display: block;
        position: absolute;
        width: 0.52rem;
        height: 0.2rem;
        right: 0.06rem;
        top: 0.06rem;
    }
    .user-row{
        width: 0.64rem;
        height: 0.72rem;
        margin: 0.08rem 0.04rem 0 0.04rem;
        float: left;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: white;
        font-size: 0.12rem;
    }
    .user-row img{
        width: 0.42rem;
        height: 0.42rem;
        display: block;
        border-radius: 50%;
        margin: 0 auto 0.06rem auto;
    }
    .activity-text{
        color: #EAEAEA;
        font-size: 0.12rem;
    }
    .activity-text span{
        display: block;
        width: 100%;
        /* transform: scale(0.8) translate(-10%,-10%); */
    }
    .panel-time{
        font-size: 0.12rem;
        color: #8FE8D3;
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        letter-spacing: 1px;
    }
    .award-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-top: 0.4rem;
    }
    .award-row{
        width: 0.84rem;
        height: 1.48rem;
        background: url('~assets/teamDraw/award-line.png') no-repeat;
        background-size: 0.84rem 0.84rem;
    }
    .award-row-box{
        width: 0.66rem;
        height: 0.62rem;
        margin: 0.15rem auto 0.3rem auto;
        display: block;
    }
    .award-row-btn{
        width: 0.83rem;
        height: 0.27rem;
        display: block;
        margin: 0 auto;
    }
    .share-menu{
        width: 100%;
        height: 3.12rem;
        background: #131135;
        padding: 0.2rem 0.2rem;
        position: fixed;
        left: 0;
        bottom:-3.12rem;
        z-index: 4444;
        transition: all 0.3s;
        visibility: hidden;
    }
    .type-text{
        color: white;
        font-size: 0.12rem;
        padding-left: 0.12rem;
    }
    .type-line{
        width: 3.32rem;
        height: 0.16rem;
    }
    .share-panel{
        width: 100%;
        height: 0.75rem;
        margin: 0.22rem auto;
        display: flex;
        justify-content: space-around;
    }
    .share-box{
        width: 0.48rem;
        height: 0.72rem;
        text-align: center;
        color: white;
        font-size: 0.12rem;
    }
    .share-box{
        width: 0.48rem;
        height: 0.72rem;
        text-align: center;
        color: white;
        font-size: 0.12rem;
    }
    .share-box img{
        width: 0.48rem;
        height: 0.48rem;
        display: block;
        margin-bottom: 0.08rem;
    }
    .share-text{
        width: 3.08rem;
        height: 0.58rem;
        margin-top: 0.13rem;
    }
    .btn-copy{
        width: 0.15rem;
        height: 0.18rem;
        right: -0.3rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    .btn-copy:active{
        transform: scale(0.9) translateY(-50%);
    }
    .btn-active:active{
        transform: scale(0.9);
    }
    .btn-scale{
        animation: zoomIn 1s linear infinite;
    }
    @keyframes zoomIn {
        0% {
            transform: scale(0.95);
        }
        50%{
            transform: scale(1.05);
        }
        100% {
            transform: scale(0.95);
        }
    }
</style>
